import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaClock, FaSpinner } from 'react-icons/fa';
import { API_CONFIG, buildApiUrl } from '../../common/api';
import logo from '../assets/logo.png';

const STATO_LABEL = {
  nuova: 'Ricevuta',
  in_gestione: 'In gestione',
  chiusa: 'Chiusa',
};

export default function SegnalazioneStato() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(buildApiUrl(`${API_CONFIG.ENDPOINTS.SEGNALAZIONI_PUBBLICHE}/stato/${token}`))
      .then((r) => r.json())
      .then((json) => {
        if (json.success) setData(json.data);
        else setError(json.message || 'Segnalazione non trovata');
      })
      .catch(() => setError('Errore di connessione'))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FFFEFA] flex items-center justify-center">
        <FaSpinner className="animate-spin text-[#c78244] text-3xl" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#FFFEFA] flex items-center justify-center px-4">
        <div className="text-center">
          <p className="text-red-500 mb-4">{error}</p>
          <Link to="/" className="text-[#c78244] underline">Torna alla home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FFFEFA]">
      <div className="w-full mang-gradient py-8 px-4 text-white text-center">
        <img src={logo} alt="Mangitalia" className="w-16 mx-auto mb-3 opacity-90" />
        <h1 className="text-2xl font-bold">Stato segnalazione</h1>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-lg mx-auto px-4 py-10"
      >
        <div className="mang-card p-6 space-y-4">
          <div className="flex items-center gap-3">
            {data.stato === 'chiusa' ? (
              <FaCheckCircle className="text-green-500 text-2xl" />
            ) : (
              <FaClock className="text-amber-500 text-2xl" />
            )}
            <div>
              <p className="text-sm text-gray-400">Stato attuale</p>
              <p className="font-bold text-lg">{STATO_LABEL[data.stato] || data.stato}</p>
            </div>
          </div>

          <div>
            <p className="text-sm text-gray-400">Oggetto</p>
            <p className="font-semibold">{data.oggetto}</p>
          </div>

          <div>
            <p className="text-sm text-gray-400">Codice riferimento</p>
            <p className="font-mono text-xs break-all">{data.token_accesso}</p>
          </div>

          <div>
            <p className="text-sm text-gray-400">Inviata il</p>
            <p>{new Date(data.created_at).toLocaleString('it-IT')}</p>
          </div>

          {data.risposta_admin && (
            <div className="bg-amber-50 rounded-xl p-4 border border-amber-100">
              <p className="text-sm font-semibold text-amber-800 mb-1">Risposta del team</p>
              <p className="text-sm text-amber-900">{data.risposta_admin}</p>
              {data.risposta_at && (
                <p className="text-xs text-amber-600 mt-2">
                  {new Date(data.risposta_at).toLocaleString('it-IT')}
                </p>
              )}
            </div>
          )}

          <Link to="/" className="block text-center text-[#c78244] underline mt-4">
            Torna alla home
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
